<script lang="ts">
  import * as _ from "lodash";
  import moment from "moment";
  import NewMessage from "./NewMessage.svelte";
  import ConversationMenu from "./ConversationMenu.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Popover from "@shared/svelte/Components/Popover/Popover.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import RetailerDistributorStore from "@retailer/svelte/stores/RetailerDistributorStore";

  import type { MessageGroup } from "@shared/types/MessageGroup";

  export let conversation: MessageGroup;
  export let messages;
  export let callbacks;
  export let goBackToPane;
  export let searchQuery;

  let showMenu = false;

  const checkAooEnabled = (retailerDistributors, conversation) => {
    const distributorIds = conversation.distributors.map(d => d.id);
    return (retailerDistributors || []).some(
      rd => rd.is_aoo_enabled && distributorIds.includes(rd.distributor.id),
    );
  };

  function markUnseenWrapper() {
    showMenu = false;
    callbacks.changeSeen(conversation, false);
  }

  function closeMenu() {
    showMenu = false;
  }
  function splitMessage(m) {
    if (!m || m == "" || !m.message) {
      return [];
    }
    if (m.order_id) {
      let mess = m.message.split("here is our order:")[1];
      if (mess) {
        mess = mess.trim();
        return mess.split("\n").map(function (x) {
          return x.replace("Qty: ", "");
        });
      }
    }
    return m.message.split("\n");
  }
  $: orderUrl = callbacks.viewOrders(conversation);
  $: isAooEnabled = checkAooEnabled($RetailerDistributorStore, conversation);
</script>

<div class="background-white">
  <div class="grid-container-header padding--small">
    <div class="media align--middle">
      <Icon
        extraClassNames="cursor-pointer margin-right--small hide--md"
        type="ArrowLeft"
        onPress={goBackToPane}
        height="20"
        width="20"
      />
      <div class="media-fluid">
        <div class="default-title--bold">{conversation.sales_reps[0].name}</div>
        <div class="default-subtitle--regular">
          {conversation.distributors.map(x => x.name).join(", ")}
        </div>
      </div>
      <div class="media align--middle">
        <div class="secondary-small--regular margin-right--smaller">
          {#if conversation.last_message}
            {moment(conversation.last_message.created_at).fromNow()}
          {/if}
        </div>
        <div id="conversation-menu-{conversation.ids[0]}">
          <Popover
            arrow={false}
            placement="bottom-center"
            bind:open={showMenu}
            overlayColor="rgba(0,0,0,0)"
          >
            <button class="button button--secondary button--smallest" slot="target">
              <Icon type="More" height="20" width="20" color="#0F1924" />
            </button>
            <div slot="content" class="content padding--sm background-white">
              <ConversationMenu {orderUrl} {closeMenu} {markUnseenWrapper} {conversation} />
            </div>
          </Popover>
        </div>
      </div>
    </div>
  </div>
  <div class="grid-container-middle padding-top--small message-window-overflow-scroll">
    <div class="padding--smaller" id="message-window-scroller">
      <div class="grid-col c12-12 c12-12--md default-body--regular">
        {#each messages as message}
          {#if message.recipient == "sales_rep"}
            {#if message.order_id}
              <div class="grid-row align-right" id="message-order-row-{message.id}">
                <div class="grid-col c12-12 c7-12--md retailer-order-message light-body--regular">
                  Order was submitted
                  <UIRouterLink
                    stateName="layout.order_details"
                    params={{ orderId: message.order_id }}
                  >
                    <button
                      class="float-right button button--secondary button--smallest margin-left--small"
                    >
                      View Order
                    </button>
                  </UIRouterLink>
                </div>
              </div>
            {/if}
            <div class="grid-row align-right padding-bottom--small">
              <div
                class="grid-col c12-12 c7-12--md light-body--regular {message.order_id
                  ? 'retailer-message-after-order'
                  : 'retailer-message'}"
              >
                {#each splitMessage(message) as messageLine}
                  <div>{messageLine}</div>
                {/each}
              </div>
              <div class="s6 padding-top--smallest">
                <span class="secondary-small--bold">
                  {#if (message.sender_user || {}).id}
                    {message.sender_user.first_name} {message.sender_user.last_name}
                  {:else}
                    Me
                  {/if}
                </span>
                <span class="secondary-small--regular">{moment(message.created_at).fromNow()}</span>
                {#if message.delivery_method}
                  <span class="secondary-small--regular">via {message.delivery_method}</span>
                {/if}
              </div>
              {#if message.state == "error"}
                <div class="s6 padding-top--smallest">
                  <span class="secondary-small--regular inline-error"
                    >There was an error in sending your message.</span
                  >
                </div>
              {/if}
            </div>
          {:else}
            <div class="grid-row padding-bottom--small">
              {#each message.media_urls || [] as media_url}
                <div>
                  <img src={media_url} alt="twilio-content" style="max-width: 40%;" />
                </div>
              {/each}
              <div class="sales-rep-message padding--smaller">
                <span class="grid-col c12-12 align-left default-body--regular">
                  {#each splitMessage(message) as messageLine}
                    <div>{messageLine}</div>
                  {/each}
                </span>
              </div>

              <div class="s6 padding-top--smallest">
                <span class="secondary-small--bold">{conversation.sales_reps[0].name}</span>
                <span class="secondary-small--regular">{moment(message.created_at).fromNow()}</span>
              </div>
            </div>
          {/if}
        {/each}
        {#if messages.length == 0 && !searchQuery}
          <div class="empty-messages align-center">
            <div class="secondary-body--bold padding-bottom-smaller">
              You don't have any messages with {conversation.sales_reps[0].name}
            </div>
            <div class="secondary-body--regular">
              Send order details, updates, or stay connected to your rep here
            </div>
          </div>
        {/if}

        {#if conversation.sales_reps[0] && conversation.sales_reps[0].deleted_at}
          <div class="empty-messages align-center">
            <div class="secondary-body--bold padding-bottom-smaller">
              This sales rep no longer has a Provi Account.
            </div>
            <div class="secondary-body--regular">
              Please reach out to the distributor if you have not been assigned a new sales rep.
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
  <div class="grid-container-middle">
    <NewMessage {conversation} {callbacks} {isAooEnabled} />
  </div>
</div>
